module.exports = __webpack_public_path__ + "media/images/icons/clock-f0b7134ed5015baf339f7686c00f95e9.svg";